import React from 'react';
import PropTypes from 'prop-types';
import Styles from './uploadItem.module.css';

const UploadItem = props => {
    const { file, progress } = props.file;

    return (
        <div className={Styles.wrapperItem}>
            <div className={Styles.leftSide}>
                <div className={Styles.progressBar}>
                    <div style={{ width: `${progress}%` }}/>
                </div>
                <label>{file.name}</label>
            </div>
            <span className={Styles.percentage}>{progress}%</span>
        </div>
    )
}

UploadItem.propTypes = {
    file: PropTypes.shape({
        file: PropTypes.shape({
            name: PropTypes.string
        }),
        progress: PropTypes.number
    })  
}


export default UploadItem;